<template>
  <b-container fluid>
    <el-page-header
      @back="() => $refs.editForm.goBack()"
      :title="$l('INDEX.btn_cancel') || '返回'"
      :content="pageHeader"
    />
    <b-row class="mt-2">
      <b-col>
        <b-card>
          <edit-form
            :disabled="isDisableEditForm"
            :params="params"
            ref="editForm"
          />
          <div class="d2-mt">
            <div class="d2-mt">
              <el-row>
                <el-col :span="20">
                  <el-button size="mini" @click="() => $refs.editForm.goBack()">
                    {{ $l('INDEX.btn_cancel') || '返回' }}
                  </el-button>
                  <el-button
                    v-if="!isDisableEditForm"
                    size="mini"
                    type="primary"
                    @click="() => $refs.editForm.save()"
                  >
                    {{ $l('INDEX.btn_save') || '保存' }}
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'master-supplierSet-detail',
  components: {
    EditForm,
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pageHeader() {
      const types = {
        add: this.$l('form_label_supplier_add') || '添加工厂档案',
        edit: this.$l('form_label_supplier_edit') || '编辑工厂档案',
        detail: this.$l('form_label_supplier_detail') || '工厂档案详情',
      }
      return types[this.pageType]
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {
    goBack() {},
    save() {
      this.$refs.editForm.save()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
